import toastr from 'toastr'

import Http from '@shared/http'

export const submitAstuteCredentials = (state, data) => {
  const {
    paths: { saveAstuteCredentialsPath },
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  return makeAstuteCredentialsRequest(saveAstuteCredentialsPath, data)
}

const makeAstuteCredentialsRequest = (path, data) => {
  return new Promise((res, rej) => {
    Http.request(
      path,
      'POST',
      JSON.stringify({ astute_credentials: data })
    ).then(
      (response) => {
        if (response.ok) {
          response.json().then(() => {
            toastr.success('Astute credentials updated successfully')
            res(true)
          })
        } else {
          toastr.warning(
            'Something went wrong saving your Astute credentials. Please try again.'
          )
          rej(false)
        }
      },
      () => {
        toastr.warning(
          'Something went wrong saving your Astute credentials. Please try again.'
        )
        rej(false)
      }
    )
  })
}
